import { EImportacaoType } from "../components/table/EImportacaoType";

type ImportacaoTypeName = { type: string; name: string };

export function getImportacaoType(
  importacaoType: EImportacaoType
): ImportacaoTypeName {
  switch (importacaoType) {
    case EImportacaoType.CARGA:
      return { type: "carga", name: "carga" };
    case EImportacaoType.ATIVACAO:
      return { type: "ativacao", name: "ativação" };
    case EImportacaoType.FUNCIONARIO:
      return { type: "funcionario", name: "importação" };
    default:
      return {} as ImportacaoTypeName;
  }
}
